import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import LoadingScreen from 'src/componentes/LoadingScreen';
import { DownloadContentFileBucket } from 'src/services/downloadFileUrl';

import './ViewDocument.css';

const SecurePDFViewer = lazy(() => import('./SecurePDFViewer'));

function ViewDocument({
  fileName,
  onlyRead,
  convertWordToPdf,
  documentName,
  documentType,
  urlCustom = null,
  parameters = {},
  ...rest
}) {
  const intl = useIntl();
  const modalRef = useRef();
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFile = async () => {
    try {
      setIsLoading(true);
      const fileBlob = await DownloadContentFileBucket(
        fileName,
        convertWordToPdf,
        urlCustom,
        (parameters = { ...parameters, isDownload: false })
      );
      const fileUrl = URL.createObjectURL(fileBlob);
      setFileData(fileUrl);
      setFileType(fileBlob.type); // Define o tipo do arquivo para a exibição condicional
    } catch (error) {
      console.error('Erro ao buscar o arquivo:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (fileName) {
      fetchFile();
    }
  }, [fileName]);

  const handleCurrentClose = () => {
    modalRef.current.close();
  };

  const isPDF = (file) =>
    file?.type === 'application/pdf' ||
    file === 'application/pdf' ||
    file?.name?.toLowerCase().endsWith('.pdf') ||
    fileName?.toLowerCase().endsWith('.pdf');

  const editActions = [
    <div
      key="toolbar-tela"
      className="d-flex align-items-center justify-content-end"
    >
      <Button color="secondary" onClick={handleCurrentClose}>
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      {/*  <Button className="ml-3" color="outline-primary">
        <MdiIcon icon="download" />
      </Button>
      <Button
        type="primary"
        onClick={handleCurrentClose}
        htmlType="submit"
        className="ml-2"
      >
        {intl.formatMessage({ id: 'aceitar' })}
      </Button>*/}
    </div>,
  ];

  const documentTitle =
    documentType && documentName
      ? `${intl.formatMessage({
          id: 'documento',
        })}: ${documentType} - ${documentName}`
      : intl.formatMessage({ id: 'documento' });

  return (
    <Dialog
      id="documento-view"
      title={documentTitle}
      ref={modalRef}
      minWidth="100%"
      minHeight="95%"
      padContent
      actions={editActions}
      isLoading={isLoading}
      {...rest}
    >
      {fileData &&
      fileType &&
      (isPDF(fileData) || isPDF(fileType)) &&
      onlyRead ? (
        <div style={{ width: '100%', height: '100%' }}>
          <div style={{ width: '100%', height: '100%' }}>
            <Suspense fallback={<LoadingScreen />}>
              <SecurePDFViewer pdfBlobUrl={fileData} onlyRead={onlyRead} />
            </Suspense>
          </div>
        </div>
      ) : (
        fileData && (
          <iframe
            src={fileData}
            width="100%"
            height="100%"
            title="PDF Document"
          />
        )
      )}
    </Dialog>
  );
}

export default ViewDocument;
